import { render } from "./forgotPassword.vue?vue&type=template&id=d281f36e&scoped=true&enter-active-class=animate__animated%20animate__fadeInDown&leave-active-class=animate__animated%20animate__fadeOutUp"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"

import "./forgotPassword.vue?vue&type=style&index=0&id=d281f36e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d281f36e"]])

export default __exports__